<template>
  <div class="mercados-crud-wrapper" style="min-height: 92vh">
    <!-- Header Principal del Módulo -->
    <div>
      <h3 class="m-0 font-weight-bold">Mercados de Reserva</h3>

    </div>

    <!-- SECCIÓN: Tarjetas Compactas de Mercados -->


    <!-- SECCIÓN: Tabla Detallada -->


    <DataTable :config="config" :data="displayedMercados" :pageRows="15" @buttonClick="dtButtonClick"></DataTable>


    <!-- Modal Formulario de Mercado -->
    <modal v-model="showModal" :disableScroll="true" :showFooter="false"
      :title="editMode ? 'Editar Mercado de Reserva' : 'Nuevo Mercado de Reserva'">
      <MercadosForm :key="formIndex" :show="showModal" :edit="editMode" :dataEdit="editData" @toggle="toggleModal"
        @reload="getMercadosReserva"></MercadosForm>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DataTable from "../../MainComponents/DataTable.vue";
import modal from "../../MainComponents/modal.vue";
import MercadosForm from "./MercadosForm.vue";

export default {
  name: "MercadosCrud",
  components: {
    DataTable,
    modal,
    MercadosForm,
  },
  data() {
    return {
      showModal: false,
      editMode: false,
      editData: {},
      formIndex: 1,
      selectedMercadoId: null,

      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Mercados",
        orderByCol: { Field: "nm", Type: "Asc" },
        selectConfig: {
          idRowData: "id",
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addMercado",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editMercado",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteMercado",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre Mercado",
            value: "nm",
          },

        ],
      },
    };
  },
  computed: {
    ...mapGetters("TarifasStore", {
      mercadosReserva: "getMercadosReserva",
      isLoading: "isLoadingMercados",
    }),
    selectedMercado() {
      if (!this.selectedMercadoId || !Array.isArray(this.mercadosReserva)) return null;
      return this.mercadosReserva.find((m) => m.id === this.selectedMercadoId) || null;
    },
    displayedMercados() {
      if (!Array.isArray(this.mercadosReserva)) return [];
      if (!this.selectedMercadoId) return this.mercadosReserva;
      return this.mercadosReserva.filter((m) => m.id === this.selectedMercadoId);
    },
  },
  methods: {
    ...mapActions("TarifasStore", ["getMercadosReserva"]),

    openMercadoModal(mercado = null) {
      this.formIndex++;
      if (mercado) {
        this.editMode = true;
        this.editData = { ...mercado };
      } else {
        this.editMode = false;
        this.editData = {};
      }
      this.showModal = true;
    },

    toggleModal(open) {
      this.showModal = open;
    },

    toggleMercadoSelection(mercadoId) {
      if (this.selectedMercadoId === mercadoId) {
        this.selectedMercadoId = null;
      } else {
        this.selectedMercadoId = mercadoId;
      }
    },

    dtButtonClick(buttonId, idSelected) {
      if (buttonId === "addMercado") {
        this.openMercadoModal();
      }
      if (buttonId === "editMercado") {
        const item = (this.mercadosReserva || []).find((m) => m.id === idSelected[0]);
        if (item) {
          this.openMercadoModal(item);
        }
      }
      if (buttonId === "deleteMercado") {
        this.deleteMercadoReserva(idSelected[0]);
      }
    },

    deleteMercadoReserva(id) {
      const deletedObject =
        (this.mercadosReserva || []).find((m) => m.id === id) || { id: id };
      const nombreMercado =
        deletedObject.nombre || deletedObject.Nombre || deletedObject.nm || id;

      this.$alert.alertConfirm({
        action: "eliminar",
        obj: "Mercado de reserva",
        route: "RVA-MercadosReserva-deleteMercadoReserva",
        data: { id: id },
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "DELETE_MERCADO_RESERVA",
            Mensaje: `Eliminacion de mercado de reserva ${nombreMercado}`,
            reference: { id: id, tp: "MERCADO_RESERVA", al: nombreMercado },
            data: deletedObject,
          });
          this.getMercadosReserva();
          this.$emit("reload");
        },
      });
    },
  },
  mounted() {
    this.getMercadosReserva();
  },
};
</script>

<style scoped>
.mercados-crud-wrapper {
  padding: 0.5rem 0;
}

.mercados-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.tabla-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* Grid de alta densidad para mercados */
.mercados-compact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.65rem;
  align-items: stretch;
}

/* Tarjeta / Chip compacta */
.mercado-chip {
  position: relative;
  display: flex;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.18s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.mercado-chip:hover {
  transform: translateY(-2px);
  border-color: #cbd5e1;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.07);
}

.mercado-chip.chip-selected {
  border-color: #2563eb;
  background: #dbeafe;
  box-shadow: 0 0 0 2px #2563eb;
}

.mercado-chip.chip-inactive {
  opacity: 0.65;
  background: #f8fafc;
}

.chip-body {
  padding: 0.55rem 0.65rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
}

/* Cabecera compacta */
.chip-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.chip-code {
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #1e40af;
}

.chip-actions {
  display: flex;
  gap: 2px;
  opacity: 0.9;
  transition: opacity 0.15s ease-in-out;
}

.mercado-chip:hover .chip-actions {
  opacity: 1;
}

.btn-icon {
  background: none;
  border: none;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 0.75rem;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
  transition: all 0.15s;
}

.btn-icon.edit {
  color: #2563eb;
  background: #eff6ff;
}

.btn-icon.delete {
  color: #dc2626;
  background: #fef2f2;
}

/* Título */
.chip-title {
  font-size: 0.82rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.35rem;
}

/* Pie */
.chip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.72rem;
  color: #64748b;
}

.chip-status-badge {
  display: flex;
  align-items: center;
}

.chip-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.chip-status-dot.active {
  background-color: #10b981;
  box-shadow: 0 0 0 2px #d1fae5;
}

.chip-status-dot.inactive {
  background-color: #94a3b8;
}

.chip-id {
  font-size: 0.68rem;
  font-family: monospace;
}

/* Botón rápido "+ Añadir" en grid */
.chip-add {
  border: 1px dashed #cbd5e1;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 600;
  min-height: 72px;
  gap: 4px;
}

.chip-add i {
  font-size: 1rem;
}

.chip-add:hover {
  border-color: #2563eb;
  color: #2563eb;
  background: #eff6ff;
}
</style>
